import styled from 'styled-components';

export const ImportLeadContainer = styled.div``;

export const ImportLeadTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
`;

export const ImportLeadContent = styled.div`
  font-size: 14px;
  color: #6c757d;
  line-height: 1.6;
`;
